import styled from '@emotion/styled';
import { BodyLarge, Column } from '../../styles';
import { shouldForwardProps } from '../../utils';
import { Box } from '@mui/material';
import { ThreadLevel } from './CommentEntry';
import { TextButton } from '../buttons';

const CommentContainer = styled(Column, shouldForwardProps)<{
    level: ThreadLevel;
    isLastEntry: boolean;
}>`
    border-bottom: ${({ theme, isLastEntry, level }) =>
        isLastEntry || level === ThreadLevel.Second
            ? 'none'
            : `${theme.colors.surfaceVariant} 1px solid`};
    padding-top: ${({ theme, level }) => (level === ThreadLevel.Second ? 0 : theme.spacing(2))};
    padding-bottom: ${({ theme, level }) => (level === ThreadLevel.Second ? 0 : theme.spacing(2))};
    gap: ${({ theme }) => theme.spacing(2)};
`;

const CommentRow = styled(Box)`
    display: grid;
    grid-template-columns: 2fr 3fr 1fr;
    align-items: center;
    gap: ${({ theme }) => theme.spacing(2)};
    border-radius: 4px;
    :target {
        background-color: ${({ theme }) => theme.colors.background};
    }
`;

const ButtonsGrid = styled(Box)`
    display: grid;
    grid-template-columns: 1fr 2fr 2fr;
    align-items: end;
`;

const CommentsButton = styled(TextButton, shouldForwardProps)`
    width: fit-content;
    justify-self: end;
`;

const UserReference = styled('a', shouldForwardProps)`
    font-family: ${({ theme }) => theme.fonts.primary};
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.4px;
    color: ${({ theme }) => theme.colors.primary};
    text-decoration: underline;
`;

const DeletedComment = styled(BodyLarge, shouldForwardProps)`
    font-style: italic;
    color: ${({ theme }) => theme.colors.disabled};
`;

export { CommentContainer, CommentRow, ButtonsGrid, CommentsButton, UserReference, DeletedComment };
